/**
 * Which rollout cohort a pharmacy belongs to. Resolved server-side and exposed as
 * `RelyingParty.rolloutGroup`; enrollment itself lives in the relying party's `settings` JSON
 * under `ROLLOUT_GROUP_SETTINGS_KEY`, which is the admin editing surface, not the routing input.
 *
 * These name a *cohort*, not a build. Do not map them back onto version numbers -- `v1`/`v2` go
 * stale the moment a third build ships, which is exactly why the backend renamed the field.
 */
export const STABLE = 'stable';
export const CANARY = 'canary';

export type RolloutGroup = typeof STABLE | typeof CANARY;

/**
 * Normalises anything the backend (or a stale settings blob) can hand us into a group we know.
 *
 * Deliberately a positive `=== CANARY` test rather than a `?? STABLE` default: a nullish default
 * only catches `null`/`undefined` and lets an unrecognised third group (say `beta`) through, which
 * would leave the sync hook permanently mismatched -- the cookie writer treats every non-canary
 * value as "delete the cookie", so the mismatch could never resolve and "Reload now" would loop.
 * Everything unknown collapses to the safe build instead.
 */
export const toRolloutGroup = (value: unknown): RolloutGroup => (value === CANARY ? CANARY : STABLE);

/** Key inside `RelyingParty#settings` that a super admin writes to enrol a pharmacy. */
export const ROLLOUT_GROUP_SETTINGS_KEY = 'rolloutGroup';
